import "./styles.scss";
import React, { useEffect, useState } from "react";
import GanttContainer from "./GanttContainer";

// import model from "./sources/models/data";

import PhaseCalculation from "../../small-components/Phase/phaseCalculationUtil";
import { withRouter } from "react-router-dom";
import fire from "../../../config/firebase";
import { keys } from "@material-ui/core/styles/createBreakpoints";

const GanttContainerApp = (props) => {
  // const data = model.data; // save to db
  const pathArr = props.location.pathname.split('/');
  const key = pathArr[pathArr.length - 1];

  const { updateCnt = 0 } = props
  const dataType = props.match.path.includes("estimates")
    ? "estimates"
    : "templates";
  const emptyData = { data: [], liks: [] };
  const [estimates, setEstimate] = useState(null);
  useEffect(() => {
    if (estimates) {
      setCnt(cnt + 1);
      props.update();
    }
  }, [estimates])

  useEffect(() => {
    updateBillingSetting();
  }, [updateCnt])

  const [cnt, setCnt] = useState(0);
  const [inital, setInital] = useState(0)
  const [resources, setResources] = useState(null);

  const updateBillingSetting = () => {
    const timebasedRef = fire.database().ref(dataType).child(key);
    timebasedRef.once("value").then((snapshot) => {
      const item = snapshot.val();
      if (item && estimates) {
        const isBillable = item.billableSwitch !== estimates.billableSwitch
        const profitMarginChanged = item.profitMargin !== estimates.profitMargin
        const targetMarginChanged = item.targetMargin !== estimates.targetMargin
        const hourlyRateChanged = item.definedhourlyRate !== estimates.definedhourlyRate

        if (isBillable || profitMarginChanged || targetMarginChanged || hourlyRateChanged) {
          timebasedRef.update(item);
          setEstimate(item)
        }
      }
    })
  }

  const onTaskChanged = (updatedData) => {

    const timebasedRef = fire.database().ref(dataType).child(key);
    timebasedRef.once("value").then(async (snapshot) => {
      const item = snapshot.val();
      timebasedRef.off("value");
      if (item) {
        item.phases = [];

        const currentState = window.gantt.json.serialize();
        currentState.data = currentState.data.filter(
          (d) => ["button", "header"].includes(d.type) === false
        );

        item.gantt = currentState;

        const phaseRef = fire.database().ref("phases");
        const phaseListSnap = await phaseRef.once("value");
        const phaseList = Object.values(phaseListSnap.val());

        let phaseOrder = 0;
        for (const current of item.gantt.data) {
          if (current.type === "project") {
            const phase = {
              phaseId: current.id,
              phaseOrder: phaseOrder++,
              phaseName: current.resource,
              tasks: [],
            };
            item.phases.push(phase);
            if (
              phaseList.find((d) => d.title === current.resource) === undefined
            ) {
              phaseRef.push({ title: current.resource });
            }
          }
        }

        let taskOrder = 0;
        for (const current of item.gantt.data) {
          if (current.type === "task") {
            current.amount = parseInt(current.amount || 0);
            current.cost = parseInt(current.cost || 0);
            current.margin = parseInt(current.margin || 0);
            current.costPerHour = parseInt(current.costPerHour || 0);
            current.resourceName = current.name || "";
            if (current.period_type === "day") {
              current.hours = current.duration * current.hours_per_day;
            }
            const phase = item.phases.find((d) => d.phaseId === current.parent);
            // const phaseGantt = item.gantt.data.find(d => d.id === current.parent);
            if (phase) {
              const task = {
                taskId: current.id,
                taskOrder: taskOrder++,
                taskName: current.resource,
                qty: 1,
                resources: [{ ...current }],
              };
              phase.tasks.push(task);
            }
          }
        }

        for (const current of item.gantt.data) {
          if (current.type === "project") {
            const phase = item.phases.find((d) => d.phaseId === current.id);
            if (phase) {
              const phaseCalculation = new PhaseCalculation(phase, [], item);
              current.margin = phaseCalculation.totalPhaseProfitPercentage();
            }
          }
        }
        //const phaseCalculation = new PhaseCalculation(phase, this.calculations, this.estimates);
        timebasedRef.update(item);
        setEstimate(item);
      }
    });
  };
  const onRoleNameAdded = (type, role) => {
    // console.log("ON ROLE NAME ADDED"); // save to db
    // console.log(type);
    // console.log(role);
  };
  const onError = (message) => {
    console.log("ON ERROR ", message);
    return true;
  };
  const reloadData = async () => {
    const timebasedRef = fire.database().ref(dataType).child(key);
    timebasedRef.once("value").then((snapshot) => {
      const item = snapshot.val();
      timebasedRef.off("value");
      if (item) {
        if (!item.data) {
          item.data = emptyData;
        }
        item.gantt.data.forEach(element => {
          if (element.type == 'project') {
            element.open = true
          }
        });
        timebasedRef.update(item);
        setEstimate(item);
      }
    });
    const resourceRef = fire.database().ref("resources");
    const snapshotResource = await resourceRef.once("value");
    //.then((snapshot) => {
    const objResource = snapshotResource.val() || {};
    const resourceKeys = Object.keys(objResource);

    resourceRef.off("value");

    const phasesRef = fire.database().ref("phases");
    const phasesTasks = await phasesRef.once("value");
    //.then((snapshot) => {
    const objPhases = phasesTasks.val();
    const phasesKeys = Object.keys(objPhases);
    phasesRef.off("value");

    const newResources = {
      internal: [
        // { name: "Designer (Visual)", cost_per_hour: 50 },
      ],
      external: [
        // { name: "Project Coordinator", cost_per_hour: 50 },
      ],
      project: [
        // { name: "Discovery", margin: 20 },
      ],
    };

    for (const resKey of resourceKeys) {
      const current = objResource[resKey];
      current.amount = parseInt(current.amount || 0);
      current.name = current.title;
      current.cost_per_hour = parseInt(current.cost || 0);

      if (current.amountType === "rate") {
        current.margin =
          (parseInt(current.amount || 0) / current.cost_per_hour - 1) * 100;
      } else {
        current.margin = parseInt(current.amount);
      }

      const itemKey = current.subtitle === "Vendor" ? "external" : "internal";
      newResources[itemKey].push(current);
    }

    for (const phaseKey of phasesKeys) {
      const item = objPhases[phaseKey];
      item.name = item.title;
      item.margin = 20;
      newResources.project.push(item);
    }

    setResources(newResources);
  };
  useEffect(() => {
    reloadData();
  }, []);

  let task = emptyData;

  if (
    estimates &&
    estimates.phases &&
    estimates.phases.length &&
    estimates.phases[0].tasks &&
    estimates.phases[0].tasks.length
  ) {
    task = estimates.phases[0].tasks[0];
  }

  if (!resources || !estimates) {
    return null;
  }

  const phaseHeight = 220 * (estimates?.phases?.length || 0); // todo esref
  let taskHeight = 0;

  if (estimates) {
    const { phases = [] } = estimates;
    for (const phase of phases) {
      const { tasks = [] } = phase;
      taskHeight += (tasks.length * 40);
      for (const task of tasks) {
        const { resources = [] } = task;
        taskHeight += (resources.length * 10);
      }
    }
  }
  let height = 400 + phaseHeight + taskHeight;
  if (taskHeight === 0) height = 220 + phaseHeight + taskHeight;
  return (
    <div className="gantt-component" style={{ height }} key={key}>
      <div className={"lightbox"} id="lightbox-view"></div>
      <div className={"names-container"}></div>
      <GanttContainer
        gantt={estimates?.gantt || null}
        key={key}
        cnt={cnt}
        task={task || {}}
        roles={resources}
        onError={onError}
        onTasksChanged={onTaskChanged}
        onRoleNameAdded={onRoleNameAdded}
        updateCnt={props.updateCnt}
        dataType={dataType}
        estimates={estimates}
      />
    </div>
  );
};

export default withRouter(GanttContainerApp);
